export default __webpack_public_path__ + "static/media/me-web.31c7b0ac.gif";